import React from 'react';

import Login from '../Login';
import Cobrands from './cobrandselection/Cobrands';
import Applications from './snapshotdatamanagement/Applications';
import Reports from './reportsmanagement/reports';
import ChangePassword from './loginmanagement/ChangePassword';

import Navbar from '../components/Navbar';

function Home(props) {
	return (
		localStorage.getItem('userData') ? (
			JSON.parse(localStorage.getItem('userData')).authentication && JSON.parse(localStorage.getItem('userData')).authentication.tempPassword ? (
				<React.Fragment>
					<Navbar displayLinks={false} flow="restricted" />
					<ChangePassword flow="restricted" prompt="Please change your password to access the rest of the application." />
				</React.Fragment>
			) : (
				JSON.parse(localStorage.getItem('userData')).cobrands.length > 1 ? (
					<React.Fragment>
						<Navbar displayLinks={false} />
						<Cobrands />
					</React.Fragment>
				) : (
					JSON.parse(localStorage.getItem('userData')).acls.includes('VW_SNP_MGMT') ? (
						<React.Fragment>
							<Navbar displayLinks={true} />
							<Applications />
						</React.Fragment>
					) : (
						<React.Fragment>
							<Navbar displayLinks={true} />
							<Reports />
						</React.Fragment>
					)
				)
			)
		) : (
			<Login login={props.login} />
		)
	);
}

export default Home;